<atlas-modal>
  <atlas-modal-header>
    {{ 'SWITCH_LOCATION_MODAL.SELECT_LOCATION' | translate }}
  </atlas-modal-header>
  <atlas-modal-content>
    <div class="business-navbar__locations-modal__info-view" *ngIf="infoText$ | async as infoText">
      <i class="material-icons">info</i>
      <span>
        {{ infoText | translate }}
      </span>
    </div>
    <div
      class="business-navbar__locations-modal__search"
      [ngClass]="{
        'business-navbar__locations-modal--fill-top': (userViewType$ | async) === viewType.USER_VIEW_TYPE_SMB
      }"
    >
      <atlas-search-box (textChange)="textChanged($event)"></atlas-search-box>
    </div>
    <atlas-tab-header>
      <atlas-location-tab [label]="allTabText$ | async" [isDefaultSelected]="true"></atlas-location-tab>
      <atlas-location-tab [label]="accountGroupTabText$ | async"></atlas-location-tab>
      <atlas-location-tab [label]="brandTabText$ | async"></atlas-location-tab>
    </atlas-tab-header>
    <ng-container *ngIf="(locations$ | async)?.length > 0 || (loading$ | async)">
      <atlas-location-list [locations]="locations$ | async" (locationSelected)="close()"></atlas-location-list>
      <glxy-infinite-scroll-trigger
        *ngIf="(locations$ | async)?.length > 0"
        (isVisible)="listScroll()"
      ></glxy-infinite-scroll-trigger>
      <div class="business-navbar__locations-modal__loading" *ngIf="loading$ | async">
        <atlas-loader [size]="50"></atlas-loader>
      </div>
    </ng-container>
    <div class="no-access-to-any">
      <glxy-empty-state *ngIf="emptySearch$ | async">
        <glxy-empty-state-title class="no-access-to-any-title">
          {{ 'SWITCH_LOCATION_MODAL.NO_SEARCH_RESULT.TITLE' | translate }}
        </glxy-empty-state-title>
        <div class="no-access-to-any-addition">
          {{ 'SWITCH_LOCATION_MODAL.NO_SEARCH_RESULT.MESSAGE' | translate }}
        </div>
      </glxy-empty-state>
      <glxy-empty-state *ngIf="empty$ | async">
        <glxy-empty-state-title class="no-access-to-any-title">
          {{ 'SWITCH_LOCATION_MODAL.EMPTY_STATES.TITLE' | translate }}
          <span class="no-access-to-any-tab-name">{{ currentTabText$ | async | translate }}.</span>
        </glxy-empty-state-title>
        <div class="no-access-to-any-addition">
          {{ 'SWITCH_LOCATION_MODAL.EMPTY_STATES.MESSAGE' | translate }}
          <b>
            {{ 'SWITCH_LOCATION_MODAL.EMPTY_STATES.CONTACT' | translate }}
          </b>
        </div>
      </glxy-empty-state>
    </div>
  </atlas-modal-content>
</atlas-modal>
